/* eslint-disable no-irregular-whitespace */
import * as React from 'react';
import { IApplicationContext } from '../../../types/applicationContext';
import { FAQContent } from '../../../components/FAQ/FAQContent';

interface IFAQItemProps {
  title: string;
  content: string | React.ReactNode;
}

const FAQ_REFERRAL_ITEMS: IFAQItemProps[] = [
  {
    title: 'Сколько стоят ваши услуги?',
    content: (
      <FAQContent>
        Поиск надежного риелтора, подключение максимального продвижения и поддержка команды — бесплатно. Оплатить нужно
        только услуги риелтора и только после успешного завершения сделки. Размер комиссии зависит от особенностей
        объекта и специфики сделки, но можно ориентироваться на среднее значение по рынку – 2,5-3% в случае продажи
        недвижимости. Услуги по покупке обычно имеют фиксированную стоимость, в среднем до 200 000 рублей.
      </FAQContent>
    ),
  },
  {
    title: 'Откуда мне знать, что риелтор — и правда профессионал?',
    content: (
      <FAQContent>
        В Сделке работают только партнёрские агентства, за которые мы ручаемся: проверили лично, подобрали по рейтингу и
        отзывам, оценили опыт решения сложных кейсов
      </FAQContent>
    ),
  },
  {
    title: 'Что делать, если мне не понравится риелтор?',
    content: (
      <FAQContent>
        По любым вопросам вы сможете обратиться к нам, и мы подключимся, чтобы помочь и подобрать другого специалиста
      </FAQContent>
    ),
  },
  {
    title: 'Риелтор поможет с документами и проверкой продавца/покупателя?',
    content: (
      <FAQContent>
        Риелтор поможет на каждом этапе — том числе, с оформлением ваших документов и проверкой документов других
        участников сделки. На самой сделке тоже будет рядом и убедится, что все расчёты правильные и безопасные.
      </FAQContent>
    ),
  },
  {
    title: 'С какой недвижимостью вы можете помочь?',
    content: (
      <FAQContent>С любой жилой: квартирой — от застройщика и на вторичке, домом, дачей и даже участком.</FAQContent>
    ),
  },
  {
    title: 'Я смогу выбрать риелтора из вашего списка самостоятельно?',
    content: (
      <FAQContent>
        Нет, после консультации мы выберем для вас специалиста с самым подходящим опытом, который ориентируется в нужном
        районе. Если вдруг отношения с этим агентом у вас не сложатся — обратитесь к нам, и мы подберём другого.
      </FAQContent>
    ),
  },
  {
    title: 'Как быстро получится продать квартиру?',
    content: (
      <FAQContent>
        На скорость продажи влияет много факторов, но по нашей статистике, вместе со Сделкой объекты продаются
        на 4–5 недель быстрее, чем самостоятельно
      </FAQContent>
    ),
  },
];

const FAQ_REFERRER_ITEMS: IFAQItemProps[] = [
  {
    title: 'Сколько стоят ваши услуги?',
    content: (
      <FAQContent>
        Поиск надёжного риелтора, подключение максимального продвижения и поддержка команды — бесплатно. Оплатить нужно
        только услуги риелтора и только после успешного завершения сделки. Размер комиссии зависит от особенностей
        объекта и специфики сделки, но можно ориентироваться на среднее значение по рынку — 2,5–3%.
      </FAQContent>
    ),
  },
  {
    title: 'Как быстро получится продать квартиру?',
    content: (
      <FAQContent>
        На скорость продажи влияет много факторов. По нашей статистике, вместе со Сделкой объекты продаются
        на 4–5 недель быстрее, чем самостоятельно.
      </FAQContent>
    ),
  },
  {
    title: 'Как узнать, что риелтор — и правда профессионал?',
    content: (
      <FAQContent>
        В Сделке работают только партнёрские агентства, за которые мы ручаемся: проверили лично, подобрали по рейтингу
        и отзывам, оценили опыт решения сложных кейсов
      </FAQContent>
    ),
  },
  {
    title: 'Что делать, если не понравится риелтор?',
    content: (
      <FAQContent>
        По любым вопросам можно обратиться к нам — мы подключимся, чтобы помочь и подобрать другого специалиста
      </FAQContent>
    ),
  },
  {
    title: 'Риелтор поможет с документами и проверкой покупателя?',
    content: (
      <FAQContent>
        Риелтор поможет на каждом этапе, в том числе с оформлением и проверкой документов и покупателей, а также
        сопроводит продавца на самой сделке и убедится в безопасности расчётов
      </FAQContent>
    ),
  },
  {
    title: 'Где можно узнать детальные правила программы?',
    content: (
      <FAQContent>
        Полные правила проведения программы доступны по{' '}
        <a
          href="https://static.cdn-cian.ru/frontend/collections-assets/cpd/prelanding/cpd-referral-prpgram-document.pdf"
          target="_blank"
          rel="noreferrer"
        >
          ссылке
        </a>
      </FAQContent>
    ),
  },
];

export const getFaqItems = (pageType: IApplicationContext['custom']['pageType']): IFAQItemProps[] => {
  if (pageType === 'referral') {
    return FAQ_REFERRAL_ITEMS;
  }

  return FAQ_REFERRER_ITEMS;
};
